"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const Loader = () => {
    return ((0, jsx_runtime_1.jsx)(Wrapper, { "data-cy": "loader", children: (0, jsx_runtime_1.jsx)("div", {}, void 0) }, void 0));
};
exports.Loader = Loader;
const Wrapper = styled_components_1.default.div `
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;

  div,
  div:before,
  div:after {
    border-radius: 50%;
    width: 2.5em;
    height: 2.5em;
    animation-fill-mode: both;
    animation: load7 1.8s infinite ease-in-out;
  }
  div {
    font-size: 10px;
    margin: auto;
    position: relative;
    text-indent: -9999em;
    transform: translateZ(0);
    animation-delay: -0.16s;
  }
  div:before,
  div:after {
    content: "";
    position: absolute;
    top: 0;
  }
  div:before {
    left: -3.5em;
    animation-delay: -0.32s;
  }
  div:after {
    left: 3.5em;
  }
  @-webkit-keyframes load7 {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }
  @keyframes load7 {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }
`;
//# sourceMappingURL=Loader.js.map